import React, { useState, useEffect } from 'react';
import { Form, Select, Checkbox, InputNumber } from 'antd';

const UserSettings = ({userIds, initialValues, formItemLayout}) => {

  const { Option } = Select;
  const [form] = Form.useForm();
  
  const [shiftOptions, setShiftOptions] = useState([]);
  
  const inputStyle = {
    marginBottom: '8px'
  }

  const checkboxStyle = {
    marginBottom: 0
  }

  useEffect(() => {
    form.resetFields();
  }, [form, initialValues])

  useEffect(() => {
      axios.post('/api/shifts/read/dto/userman/slim').then((response) => {
          setShiftOptions(response.data.data)
      })
  }, [])

  const formChanged = () => {

    const newValues = {
      ...initialValues,
      ...form.getFieldsValue(),
    }

    _.isEqual(initialValues, newValues) && form.resetFields()
  }

  return (
    <>
      {userIds &&
        <Form
            form={form}
            name="userSettingsForm"
            {...formItemLayout}
            labelAlign="left"
            initialValues={initialValues}
            autoComplete="off"
            hideRequiredMark
            onValuesChange={formChanged}
        >
          <Form.Item label="Work week" name="workWeek" style={inputStyle}>
            <Select>
              {shiftOptions.map(shift => <Option key={shift.id} value={shift.id}>{shift.name}</Option>)}
            </Select>
          </Form.Item>
          <Form.Item label="Max recycle bin (days)" name="recycleHoldDays" style={inputStyle}>
            <InputNumber min={1} step={1} max={365} style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item label="Workflow status" name="workflowEnabled" style={inputStyle}>
            <Select>
              <Option value={true}>Available</Option>
              <Option value={false}>Out Of Office</Option>
            </Select>
          </Form.Item>
          <Form.Item label="Double click settings" name="defaultDblClick" style={{ marginBottom: '20px' }}>
            <Select>
              <Option value={0}>View and Launch</Option>
              <Option value={1}>Check Out and Launch</Option>
              <Option value={2}>Get Latest and Launch</Option>
              <Option value={3}>Prompt View Default</Option>
              <Option value={4}>Prompt Check Out Default</Option>
            </Select>
          </Form.Item>
          <Form.Item name="promptBeforeSave" valuePropName="checked" style={checkboxStyle}>
            <Checkbox>Prompt before save</Checkbox>
          </Form.Item>
          <Form.Item name="promptBeforeDelete" valuePropName="checked" style={checkboxStyle}>
            <Checkbox>Prompt before delete</Checkbox>
          </Form.Item>
          <Form.Item name="promptBeforeCancel" valuePropName="checked" style={checkboxStyle}>
            <Checkbox>Prompt before cancel</Checkbox>
          </Form.Item>
          <Form.Item name="workflowNotifications" valuePropName="checked" style={checkboxStyle}>
          <Checkbox>Send notifications for workflow</Checkbox>
          </Form.Item>
          <Form.Item name="allowWorkingDirectoryOverride" valuePropName="checked" style={checkboxStyle}>
            <Checkbox>Allow working directory override</Checkbox>
          </Form.Item>
          <Form.Item name="allowMaintainExistVersion" valuePropName="checked" style={checkboxStyle}>
            <Checkbox>Allow maintain existing version</Checkbox>
          </Form.Item>
          <Form.Item name="allowEmptyVersionNotes" valuePropName="checked" style={checkboxStyle}>
            <Checkbox>Allow empty version notes</Checkbox>
          </Form.Item>
          <Form.Item name="allowEmptyDescription" valuePropName="checked" style={checkboxStyle}>
            <Checkbox>Allow empty description</Checkbox>
          </Form.Item>
          <Form.Item name="allowRemoveLocalCopyOvrd" valuePropName="checked" style={checkboxStyle}>
            <Checkbox>Allow remove local copy override</Checkbox>
          </Form.Item>
          <Form.Item name="allowGetLocalCopyOvrd" valuePropName="checked" style={checkboxStyle}>
            <Checkbox>Allow get local copy override</Checkbox>
          </Form.Item>
          <Form.Item name="allowEmptyComments" valuePropName="checked" style={checkboxStyle}>
            <Checkbox>Allow empty comments</Checkbox>
          </Form.Item>
          <Form.Item name="allowWebToolsAccess" valuePropName="checked" style={checkboxStyle}> 
            <Checkbox>Allow WebTools access</Checkbox>
          </Form.Item>
          <Form.Item name="workflowView" valuePropName="checked" style={checkboxStyle}>
            <Checkbox>Show consolidated workflow view</Checkbox>
          </Form.Item>
          <Form.Item name="workflowDialogContinuation" valuePropName="checked" style={checkboxStyle}>
            <Checkbox>Enable workflow dialog continuation</Checkbox>
          </Form.Item>
        </Form>
      }
    </>
  )
}

export default UserSettings;